import { cn } from '@/lib/utils'

export const PageContainer = ({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn('@container relative pt-header pb-50', className)}>{children}</div>
}
